<template>
  <div>
    <div v-if="$vuetify.breakpoint[breakpoint]">
      <slot />
    </div>
  </div>
</template>

<script>
// import { fragment } from "vue-fragment";

export default {
  //   components: { fragment },
  props: {
    point: {
      type: String,
      required: true,
    },
  },
  computed: {
    breakpoint() {
      switch (this.point) {
        case "smUp":
          return "xsOnly";
        case "mdUp":
          return "smAndDown";
        case "lgUp":
          return "mdAndDown";
        case "xsDown":
          return "smAndUp";
        case "smDown":
          return "mdAndUp";
        case "mdDown":
          return "lgAndUp";
        case "lgDown":
          return "xlOnly";
        //
        case "smAndUp":
          return "xsOnly";
        case "mdAndUp":
          return "smAndDown";
        case "lgAndUp":
          return "mdAndDown";
        case "xsOnly":
          return "smAndUp";
        case "smAndDown":
          return "mdAndUp";
        case "mdAndDown":
          return "lgAndUp";
        case "lgAndDown":
          return "xlOnly";
        default:
          return "xlOnly";
      }
    },
  },
};
</script>
